/**
 * Store: Last viewed products
 * -----------------------------------------------------------------------------
 * Shares last viewed products.
 * - Tied to the predictive search and product carousel components.
 * - Only JSDOC custom parameters, ignore module state or object.
 *
 */
import { defineStore } from 'pinia';

const useLastViewedProductsStore = defineStore('last-viewed-products', {
  state: () => ({
    products: [],
  }),

  actions: {
    /**
     * Commit viewed products.
     * @param {Number} id - Shopify product ID
     */
    addViewedProduct(id) {
      const limit = 12;
      const products = this.products;

      if (products.includes(id)) {
        return;
      }

      products.unshift(id);

      if (products.length > limit) {
        products.length = limit;
      }

      this.products = products;
    },
  },
  persist: {
    pick: ['products'],
  },
});

export default useLastViewedProductsStore;
